<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-package-variant-closed"
    />
    <RVModificationTable
      ref="rvModificationTable"
      @setPageMode="setPageMode"
      @cancel="headlineText = $t('condAdmin.rvModificationList.headline')"
    />
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline';
import RVModificationTable from './components/RVModificationTable.vue';

export default {
  name: 'RVModification',
  components: {
    Headline,
    RVModificationTable
  },
  data () {
    return {
      pageMode: 'table', // values: table, edit
      headlineText: this.$t('condAdmin.rvModificationList.headline')
    };
  },
  async beforeRouteLeave (to, from, next) {
    if (await this.$refs.rvModificationTable.checkLeave() === true) next();
  },
  methods: {
    setPageMode (mode) {
      this.pageMode = mode;
      switch (mode) {
        case 'create':
          this.headlineText = this.$t('condAdmin.rvModificationList.create');
          break;
        case 'edit':
          this.headlineText = this.$t('condAdmin.rvModificationList.edit');
          break;
        default: // 'table':
          this.headlineText = this.$t('condAdmin.rvModificationList.headline');
          break;
      }
    }
  }
};
</script>

<style scoped>
</style>
